var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import '@styles/webdesktop/stylesheets/typography.scss';
import { Foreground } from '@front/sharedcomponents/Styles';
import { TextState } from './TextState';
import { Typography } from '../Typography/Typography';
export const Label = (_a) => {
    var { color = Foreground.Secondary, state = TextState.Default, className } = _a, restProps = __rest(_a, ["color", "state", "className"]);
    const typographyClassNames = ['simple-text', color, state === TextState.Default ? '' : ` ${state}`, className];
    const typographyClassName = typographyClassNames.filter(Boolean).join(' ');
    return _jsx(Typography, Object.assign({}, restProps, { className: typographyClassName }));
};
